import type en from '../en/settings'
import type { Translation } from '../types'

/** Settings */
const settings: Translation<typeof en> = {
  "settings.mail.sent": "Correo de prueba enviado a {to} a través de {host}. Su propio servidor de correo está en uso a partir de ahora.",
  "settings.mail.testFailed": "No se pudo enviar el correo de prueba",
  "settings.mail.inUse": "En uso: su propio servidor de correo.",
  "settings.mail.notYet": "Todavía no está en uso: envíe un correo de prueba para empezar a usar su propio servidor de correo. Mientras tanto, el correo pasa por el servidor de correo de la plataforma.",
  "settings.mail.sendTest": "Enviar correo de prueba",
  "settings.mail.testHint": "Va a su propia dirección, con la configuración guardada: guarde primero sus cambios.",
  "settings.saved": "Configuración guardada",
  "settings.saveFailed": "No se pudo guardar la configuración",
  "settings.companySaved": "Datos de la empresa guardados",
  "settings.companySaveFailed": "No se pudieron guardar los datos de la empresa",
  "settings.licenseRenewed": "¡Licencia renovada!",
  "settings.licenseInvalid": "Código de licencia no válido o ya usado",
  "settings.title": "Configuración de la empresa",
  "settings.save": "Guardar configuración",
  "settings.companyInfo": "Datos de la empresa",
  "settings.companyName": "Nombre de la empresa",
  "settings.customDomain": "Dominio propio",
  "settings.customDomainHint": "La dirección en la que se inicia sesión con su propia marca. Una vez guardada, apunte su DNS a esta plataforma y demuestre con un registro TXT (se muestra aquí) que es suya. La plataforma se encarga del certificado HTTPS.",
  "settings.saveCompany": "Guardar datos de la empresa",
  "settings.signIns": "Inicios de sesión",
  "settings.sessionDays": "Duración máxima de la sesión (días)",
  "settings.sessionDaysHelp": "Después, todos en la empresa vuelven a iniciar sesión: de 1 día a 6 meses (183 días), 7 por defecto. Se cuenta desde el inicio de sesión; un cambio también se aplica a las sesiones en curso.",
  "settings.idleMax": "Cerrar sesión tras un tiempo sin actividad: como máximo",
  "settings.idleHelp": "Una sesión que nadie usa durante este tiempo se cierra (8 horas por defecto). Cada persona puede elegir un tiempo menor en Mi perfil.",
  "settings.idleOffWarning": "Esto permite desactivar una de las protecciones de cuenta de esta empresa: una sesión abierta en un ordenador desatendido sigue iniciada hasta alcanzar su duración máxima.",
  "settings.idleOffQuestion": "¿Permitir desactivarla?",
  "settings.idleOffLabel": "Permitir que cada persona desactive para sí el cierre de sesión por inactividad",
  "settings.syncInterval": "Intervalo de sincronización",
  "settings.dataPeriod": "Periodo de datos predeterminado",
  "settings.retention": "Retención de datos",
  "settings.automation": "Automatización y alertas",
  "settings.autoApply": "Aplicar automáticamente los valores predeterminados a sitios nuevos",
  "settings.autoApplySub": "Aplicar automáticamente la plantilla predeterminada de la empresa cuando un sitio se conecta",
  "settings.emailAlerts": "Alertas por correo electrónico",
  "settings.emailAlertsSub": "Enviar correos de alerta a los administradores de la empresa cuando los sitios se desconectan o saltan alertas críticas",
  "settings.webhookAlerts": "Alertas por webhook",
  "settings.webhookAlertsSub": "Enviar los datos de las alertas por POST a las URL de webhook configuradas",
  "settings.smtp.title": "Correo propio / SMTP",
  "settings.smtp.intro": "Las alertas y los correos de configuración VPN salen por su propio servidor de correo, desde su propia dirección. Las invitaciones y los restablecimientos de contraseña siempre vienen de la plataforma, así que ningún servidor de correo externo ve nunca un enlace de inicio de sesión. Déjelo en blanco para usar la plataforma para todo.",
  "settings.smtp.host": "Host SMTP",
  "settings.smtp.userPlaceholder": "usted@dominio.es",
  "settings.smtp.keepPlaceholder": "(déjelo en blanco para conservarla)",
  "settings.smtp.passwordPlaceholder": "Contraseña SMTP",
  "settings.smtp.encrypted": "Cifrado con AES-256 — nunca se devuelve al navegador",
  "settings.smtp.fromEmail": "Correo del remitente",
  "settings.smtp.fromEmailPlaceholder": "hola@suempresa.es",
  "settings.smtp.fromName": "Nombre del remitente",
  "settings.overview": "Resumen de la empresa",
  "settings.slug": "Identificador",
  "settings.created": "Creada",
  "settings.brandingText": "Personalice el aspecto de su plataforma: colores, logotipo, nombre de la aplicación, fuentes y CSS propio.",
  "settings.openBranding": "Abrir el editor de marca →",
  "settings.license": "Licencia",
  "settings.expires": "Caduca",
  "settings.maxSites": "Sitios máx.",
  "settings.maxUsers": "Usuarios máx.",
  "settings.renewLicense": "Renovar licencia",
  "settings.licenseCode": "Código de licencia",
  "settings.renew": "Renovar",
  "settings.more": "Más configuración",
  "settings.link.branding": "Marca y apariencia",
  "settings.link.vpn": "Configuración VPN",
  "settings.link.users": "Usuarios y roles",
  "settings.dns.ok": "Configurado",
  "settings.dns.missing": "Falta",
  "settings.dns.update": "Necesita un cambio",
  "settings.dns.unknown": "No se pudo comprobar",
  "settings.dns.title": "Registros DNS para el correo de {domain}",
  "settings.dns.freeMail": "{domain} pertenece a un proveedor de correo: nadie salvo ese proveedor puede añadir registros allí, así que los destinatarios pueden tratar este correo como spam. Use una dirección de su propio dominio.",
  "settings.dns.addRecords": "Añada estos registros TXT en el proveedor DNS de {domain} para que los servidores de correo receptores acepten el correo en lugar de marcarlo como spam.",
  "settings.dns.copyName": "Copiar el nombre del registro {type}",
  "settings.dns.copyValue": "Copiar el valor del registro {type}",
  "settings.dns.now": "Ahora:",
  "settings.checkNow": "Comprobar ahora",
  "settings.domain.proven": "Dominio verificado",
  "settings.domain.serves": "{domain} ya muestra su panel.",
  "settings.domain.notFound": "Todavía no se ha encontrado",
  "settings.domain.dnsSlow": "Los cambios de DNS pueden tardar en aparecer — inténtelo de nuevo en unos minutos.",
  "settings.domain.checkFailed": "Error en la comprobación",
  "settings.domain.ownershipProven": "Propiedad verificada",
  "settings.domain.ownershipNotYet": "Propiedad aún no verificada",
  "settings.domain.dnsHere": "El DNS apunta aquí",
  "settings.domain.dnsNotYet": "El DNS aún no apunta aquí",
  "settings.domain.addTxt": "Añada este registro TXT en su proveedor DNS. Hasta que se encuentre, {domain} muestra una página «en preparación»",
  "settings.domain.releaseBefore": "; si no se encuentra antes del ",
  "settings.domain.releaseAfter": ", el dominio se libera de su empresa",
  "settings.domain.copyName": "Copiar el nombre del registro",
  "settings.domain.copyValue": "Copiar el valor del registro",
  "settings.checked": " · comprobado {when}",
  "settings.domain.pointA": "Haga que un registro A de {domain} apunte también a {ip}.",
  "settings.domain.thisServer": "este servidor",
  "settings.sso.saved": "Inicio de sesión único guardado",
  "settings.sso.intro": "Las personas inician sesión con su propio proveedor de identidad (OpenID Connect: Microsoft Entra ID, Google Workspace, Okta, Keycloak y otros). Su autenticación multifactor sustituye a la nuestra. Registre estas direcciones de retorno del inicio de sesión en el proveedor:",
  "settings.sso.copy": "Copiar {url}",
  "settings.sso.issuer": "Emisor",
  "settings.sso.clientId": "ID de cliente",
  "settings.sso.clientSecret": "Secreto de cliente",
  "settings.sso.secretStored": "Guardado — escriba uno nuevo para sustituirlo",
  "settings.sso.on": "El inicio de sesión único está activado",
  "settings.sso.autoJoin": "Las personas de los dominios verificados se unen a la empresa en su primer inicio de sesión",
  "settings.sso.withRole": "Con el rol",
  "settings.sso.noRole": "Sin rol (solo lo que todos pueden ver)",
  "settings.sso.require": "Exigir inicio de sesión único: sin inicio de sesión con contraseña para las personas de los dominios verificados",
  "settings.sso.breakGlassNote": "Los administradores de emergencia (abajo) conservan su contraseña y su inicio de sesión en dos pasos, para cuando el proveedor de identidad no esté disponible.",
  "settings.sso.save": "Guardar inicio de sesión único",
  "settings.sso.domains": "Dominios",
  "settings.sso.domainsIntro": "Verifique un dominio con un registro TXT: sus direcciones inician sesión (y se vinculan) sin contraseña",
  "settings.sso.domainsUntil": " — hasta que se verifique uno, solo pueden usar el inicio de sesión único las personas que lo vincularon desde su perfil",
  "settings.sso.proven": "Verificado",
  "settings.sso.notProven": "Aún no verificado",
  "settings.sso.removeConfirm": "¿Quitar {domain}? Sus personas solo podrán iniciar sesión con inicio de sesión único tras vincularlo ellas mismas.",
  "settings.sso.domainRemoved": "Dominio quitado",
  "settings.sso.copyName": "Copiar el nombre del registro de {domain}",
  "settings.sso.copyValue": "Copiar el valor del registro de {domain}",
  "settings.sso.domainAdded": "Dominio añadido",
  "settings.sso.domainToAdd": "Dominio que añadir",
  "settings.sso.addDomain": "Añadir dominio",
  "settings.sso.breakGlass": "Administradores de emergencia",
  "settings.apikeys.revoked": "Clave de API revocada",
  "settings.apikeys.revokeFailed": "No se pudo revocar la clave",
  "settings.apikeys.copied": "Copiado en el portapapeles",
  "settings.apikeys.title": "Claves de API",
  "settings.apikeys.subtitle": "Acceso a su cuenta para scripts y otros sistemas",
  "settings.apikeys.create": "Crear clave de API",
  "settings.apikeys.createdTitle": "Clave de API creada: cópiela ahora",
  "settings.apikeys.createdText": "La clave completa solo se muestra ahora. Guárdela en un lugar seguro.",
  "settings.apikeys.hide": "Ocultar clave",
  "settings.apikeys.show": "Mostrar clave",
  "settings.apikeys.dismiss": "Ya la he guardado: cerrar",
  "settings.apikeys.prefix": "Prefijo",
  "settings.apikeys.permissions": "Permisos",
  "settings.apikeys.lastUsed": "Último uso",
  "settings.apikeys.expires": "Caduca",
  "settings.apikeys.created": "Creada",
  "settings.apikeys.empty": "Todavía no hay claves de API",
  "settings.apikeys.revokedBadge": "Revocada",
  "settings.apikeys.none": "Ninguno",
  "settings.apikeys.never": "Nunca",
  "settings.apikeys.revokeConfirm": "¿Revocar «{name}»? No se puede deshacer.",
  "settings.apikeys.revoke": "Revocar clave",
  "settings.apikeys.revokeNamed": "Revocar {name}",
  "settings.apikeys.nameRequired": "El nombre es obligatorio",
  "settings.apikeys.createFailed": "No se pudo crear la clave",
  "settings.apikeys.keyName": "Nombre de la clave *",
  "settings.apikeys.keyNamePlaceholder": "p. ej., canalización CI/CD, script de monitorización",
  "settings.apikeys.days30": "30 días",
  "settings.apikeys.days90": "90 días",
  "settings.apikeys.year1": "1 año",
  "settings.apikeys.permHint": "Elija los permisos de esta clave. Una clave necesita al menos uno.",
  "settings.apikeys.createKey": "Crear clave",
  "settings.branding.resetDone": "Imagen de marca restablecida a los valores predeterminados",
  "settings.branding.resetFailed": "Error al restablecer",
  "settings.branding.saved": "Imagen de marca guardada",
  "settings.branding.saveFailed": "No se pudo guardar la imagen de marca",
  "settings.branding.title": "Imagen de marca",
  "settings.branding.subtitle": "El aspecto del panel para su equipo",
  "settings.branding.resetConfirm": "¿Restablecer toda la imagen de marca a los valores de Velanox? Se eliminarán todos los colores, fuentes y logotipos propios.",
  "settings.branding.reset": "Restablecer valores predeterminados",
  "settings.branding.save": "Guardar imagen de marca",
  "settings.branding.identity": "Identidad",
  "settings.branding.appName": "Nombre de la aplicación",
  "settings.branding.logoUrl": "URL del logotipo",
  "settings.branding.faviconUrl": "URL del favicon",
  "settings.branding.loginBanner": "Imagen del banner de inicio de sesión",
  "settings.branding.colors": "Colores",
  "settings.branding.color.primaryColor": "Principal",
  "settings.branding.color.secondaryColor": "Secundario",
  "settings.branding.color.accentColor": "Acento",
  "settings.branding.color.backgroundColor": "Fondo",
  "settings.branding.color.sidebarColor": "Barra lateral",
  "settings.branding.color.textColor": "Texto",
  "settings.branding.colourOf": "Color {name}",
  "settings.branding.colourCode": "Código de color {name}",
  "settings.branding.themeDefault": "predeterminado del tema",
  "settings.branding.typography": "Tipografía y forma",
  "settings.branding.font": "Fuente",
  "settings.branding.fontDefault": "Predeterminada de la plataforma (Geist)",
  "settings.branding.radius": "Radio de las esquinas",
  "settings.branding.radiusDefault": "Predeterminado de la plataforma",
  "settings.branding.radius.0": "Recto (0px)",
  "settings.branding.radius.4": "Sutil (4px)",
  "settings.branding.radius.8": "Suave (8px)",
  "settings.branding.radius.12": "Redondeado (12px)",
  "settings.branding.radius.16": "Muy redondeado (16px)",
  "settings.branding.customCss": "CSS personalizado",
  "settings.branding.customCssHint": "Avanzado: CSS que se añade a cada página. Como máximo 50.000 caracteres.",
  "settings.branding.cssPlaceholder": "/* CSS personalizado */",
  "settings.branding.preview": "Vista previa en directo",
  "settings.branding.applyPreview": "Aplicar vista previa",
  "settings.branding.sampleBadge": "Etiqueta de ejemplo",
  "settings.branding.previewHint": "Elija «Aplicar vista previa» para ver los cambios en directo en la barra lateral",
  "settings.messages.part.emailSubject": "Asunto del correo",
  "settings.messages.part.emailBody": "Texto del correo",
  "settings.messages.part.whatsappBody": "Texto de WhatsApp",
  "settings.messages.part.rcsBody": "Texto RCS",
  "settings.messages.wa.approved": "Aprobado por WhatsApp: se envía su texto",
  "settings.messages.wa.rejected": "Rechazado por WhatsApp. Se envía el texto predeterminado.",
  "settings.messages.wa.rejectedWhy": "Rechazado por WhatsApp: {reason}. Se envía el texto predeterminado.",
  "settings.messages.wa.failed": "Aún no enviado a revisión ({reason}). Se reintenta cada 30 minutos; mientras tanto se envía el texto predeterminado.",
  "settings.messages.wa.failedPlain": "Aún no enviado a revisión. Se reintenta cada 30 minutos; mientras tanto se envía el texto predeterminado.",
  "settings.messages.wa.paused": "Pausado por WhatsApp. Se envía el texto predeterminado.",
  "settings.messages.wa.disabled": "Desactivado por WhatsApp. Se envía el texto predeterminado.",
  "settings.messages.wa.pending": "Esperando la aprobación de WhatsApp (normalmente en un día). Mientras tanto se envía el texto predeterminado.",
  "settings.messages.notChanged": "Sin cambios",
  "settings.messages.notSaved": "No guardado",
  "settings.messages.tryAgain": "Vuelva a intentarlo en un momento.",
  "settings.messages.title": "Mensajes",
  "settings.messages.subtitle": "Lo que sus usuarios reciben por {channels}. Cambie el texto o desactive un mensaje.",
  "settings.messages.channel.email": "correo electrónico",
  "settings.messages.channels2": "{a} y {b}",
  "settings.messages.channels3": "{a}, {b} y {c}",
  "settings.messages.defaultsPending": "Su propia cuenta de WhatsApp aún no ha aprobado los textos estándar: hasta entonces, los mensajes de WhatsApp salen como texto simple, que solo llega en las 24 horas siguientes al último mensaje del destinatario.",
  "settings.messages.variablesInfo": "Las palabras entre llaves dobles, como {example}, se rellenan al enviar el mensaje. Los enlaces solo proceden de las variables de enlace. Las invitaciones y los restablecimientos de contraseña afectan a la seguridad, así que siempre se envían.",
  "settings.messages.noLicence": "Su licencia no incluye la modificación de mensajes. Aun así, puede restablecer un mensaje a su valor predeterminado.",
  "settings.messages.sentEmail": "Enviado por correo electrónico",
  "settings.messages.sentWhatsapp": "Enviado por WhatsApp",
  "settings.messages.sentRcs": "Enviado por RCS",
  "settings.messages.ownWording": "Texto propio",
  "settings.messages.alwaysSent": "Siempre se envía",
  "settings.messages.on": "Activado",
  "settings.messages.off": "Desactivado",
  "settings.messages.sendNamed": "Enviar «{label}»",
  "settings.messages.resetConfirm": "¿Restablecer «{label}» al texto predeterminado?",
  "settings.messages.resetDone": "Restablecido el predeterminado",
  "settings.messages.ownMeta": "Su propio WhatsApp pasa por Meta: sus textos son las plantillas indicadas en Configuración de la empresa → WhatsApp.",
  "settings.messages.twilioOnly": "Los textos de WhatsApp se pueden cambiar cuando la plataforma envía WhatsApp a través de Twilio.",
  "settings.messages.waRules": "Un solo párrafo, palabras antes de la primera variable y después de la última, nunca dos variables seguidas. Un texto modificado necesita la aprobación de WhatsApp antes de usarse.",
  "settings.messages.rcsNote": "Llega a la aplicación de mensajes del propio teléfono. Se usa de inmediato: los textos RCS no necesitan aprobación.",
  "settings.messages.insertVariable": "Insertar una variable",
  "settings.messages.example": "Ejemplo: {value}",
  "settings.messages.required": "* debe permanecer en el texto del correo",
  "settings.messages.save": "Guardar",
  "settings.messages.backToDefault": "Volver al predeterminado",
  "settings.messages.previewRegion": "Vista previa con valores de ejemplo",
  "settings.messages.preview": "Vista previa",
  "settings.vpn.downloadFailed": "Error en la descarga",
  "settings.vpn.mayBeCreating": "Es posible que el archivo VPN aún se esté creando.",
  "settings.vpn.creating": "Cuenta VPN solicitada",
  "settings.vpn.creatingText": "Se está creando su cuenta VPN. Actualice dentro de 30 segundos.",
  "settings.vpn.createFailed": "No se pudo crear la cuenta VPN",
  "settings.vpn.contactAdmin": "Póngase en contacto con su administrador.",
  "settings.vpn.regenerated": "Nuevo archivo VPN creado",
  "settings.vpn.regeneratedText": "Descargue su nuevo archivo a continuación.",
  "settings.vpn.regenerateFailed": "No se pudo crear un archivo VPN nuevo",
  "settings.vpn.memberConfirm": "¿Crear un archivo VPN nuevo para «{name}»? El actual dejará de funcionar.",
  "settings.vpn.memberDone": "Cuenta VPN solicitada",
  "settings.vpn.memberDoneText": "Se está creando un archivo VPN nuevo para {name}.",
  "settings.vpn.suspendConfirm": "¿Suspender la VPN de «{name}»?",
  "settings.vpn.enableConfirm": "¿Volver a activar la VPN de «{name}»?",
  "settings.vpn.suspended": "VPN suspendida",
  "settings.vpn.enabled": "VPN activada",
  "settings.vpn.notChanged": "Sin cambios",
  "settings.vpn.siteRegenerated": "Nuevo archivo VPN creado para el sitio",
  "settings.vpn.subtitle": "OpenVPN: una red independiente para cada empresa",
  "settings.vpn.mine": "Mi cuenta VPN",
  "settings.vpn.lastSeen": "Visto por última vez",
  "settings.vpn.download": "Descargar .ovpn",
  "settings.vpn.regenerateMineConfirm": "¿Crear un archivo VPN nuevo? Su archivo .ovpn actual dejará de funcionar.",
  "settings.vpn.regenerateHint": "Archivo nuevo: si el actual se ha perdido o pudo verlo otra persona",
  "settings.vpn.regenerate": "Renovar el certificado",
  "settings.vpn.suspendedMine": "Su cuenta VPN está suspendida. Póngase en contacto con su administrador.",
  "settings.vpn.noAccount": "Todavía no hay cuenta VPN.",
  "settings.vpn.createMine": "Crear mi cuenta VPN",
  "settings.vpn.network": "Red VPN de la empresa",
  "settings.vpn.usersNet": "Red de usuarios",
  "settings.vpn.sitesNet": "Red de sitios",
  "settings.vpn.isolation": "Los usuarios pueden llegar a todos los sitios de la empresa. Los sitios no pueden llegar unos a otros.",
  "settings.vpn.networkPending": "Se está configurando la red VPN…",
  "settings.vpn.all": "Todas las cuentas VPN",
  "settings.vpn.count": { one: "{count} cuenta", other: "{count} cuentas" },
  "settings.vpn.account": "Cuenta",
  "settings.vpn.type": "Tipo",
  "settings.vpn.type.USER": "Persona",
  "settings.vpn.type.SITE": "Sitio",
  "settings.vpn.empty": "Todavía no hay cuentas VPN",
  "settings.vpn.downloadSite": "Descargar el archivo VPN del sitio",
  "settings.vpn.siteConfirm": "¿Crear un archivo VPN nuevo para «{name}»? El actual dejará de funcionar.",
  "settings.vpn.suspend": "Suspender VPN",
  "settings.vpn.enable": "Activar VPN",
  "settings.vpn.createFor": "Crear cuenta VPN",
  "settings.vpn.setup": "Instrucciones de configuración",
  "settings.vpn.tab.personal": "Dispositivo personal",
  "settings.vpn.tab.unifi": "UniFi OS (router del sitio)",
  "settings.vpn.pc.1": "Descargue OpenVPN Connect desde https://openvpn.net/client/",
  "settings.vpn.pc.2": "Elija + y después «Upload File»",
  "settings.vpn.pc.3": "Seleccione su archivo .ovpn",
  "settings.vpn.pc.4": "Elija Connect: no se necesita usuario ni contraseña",
  "settings.vpn.pc.note": "Se necesita OpenVPN Connect 3.x. El antiguo OpenVPN GUI también funciona.",
  "settings.vpn.linux.1": "Instalar: sudo apt install openvpn (o el equivalente para su distribución)",
  "settings.vpn.linux.2": "Conectar: sudo openvpn --config su-nombre.ovpn",
  "settings.vpn.linux.3": "O use NetworkManager: importe el archivo .ovpn desde el menú de red",
  "settings.vpn.ios.1": "Instale «OpenVPN Connect» desde la App Store",
  "settings.vpn.ios.2": "Envíe el archivo .ovpn a su dispositivo por AirDrop o correo electrónico",
  "settings.vpn.ios.3": "Elija «Abrir con OpenVPN Connect» cuando se le pregunte",
  "settings.vpn.ios.4": "Elija Add y después Connect",
  "settings.vpn.android.1": "Instale «OpenVPN Connect» desde Play Store",
  "settings.vpn.android.2": "Comparta el archivo .ovpn con OpenVPN Connect",
  "settings.vpn.android.3": "Elija Import y después Connect",
  "settings.vpn.security": "Seguridad:",
  "settings.vpn.securityText": "Mantenga su archivo .ovpn en privado: es su acceso personal. Si se ha perdido o pudo verlo otra persona, cree un archivo nuevo arriba; el antiguo dejará de funcionar.",
  "settings.webhooks.event.site.offline": "Sitio sin conexión",
  "settings.webhooks.event.site.online": "Sitio de nuevo en línea",
  "settings.webhooks.event.alert.critical": "Alertas críticas",
  "settings.webhooks.event.alert.error": "Alertas de error",
  "settings.webhooks.event.alert.warning": "Advertencias",
  "settings.webhooks.event.alert.info": "Información",
  "settings.webhooks.event.license.expiring": "Licencia a punto de caducar",
  "settings.webhooks.deleted": "Webhook eliminado",
  "settings.webhooks.deleteFailed": "No se pudo eliminar el webhook",
  "settings.webhooks.toggleFailed": "No se pudo cambiar el webhook",
  "settings.webhooks.testDelivered": "Prueba entregada",
  "settings.webhooks.answered": "Su endpoint respondió {code}.",
  "settings.webhooks.testFailed": "Error en la prueba",
  "settings.webhooks.noResponse": "Sin respuesta",
  "settings.webhooks.unreachable": "Compruebe que la URL del webhook es accesible y responde con un estado 2xx.",
  "settings.webhooks.title": "Webhooks",
  "settings.webhooks.subtitle": "Eventos enviados a sus propios sistemas en cuanto ocurren, por HTTP POST",
  "settings.webhooks.add": "Añadir webhook",
  "settings.webhooks.eventsLabel": "Eventos:",
  "settings.webhooks.info": "Cada webhook recibe los eventos elegidos para él (todos si no se elige ninguno). Los datos se firman con HMAC-SHA256 y el secreto de su webhook.",
  "settings.webhooks.events": "Eventos",
  "settings.webhooks.updated": "Última actualización",
  "settings.webhooks.empty": "Todavía no hay webhooks",
  "settings.webhooks.allEvents": "Todos los eventos",
  "settings.webhooks.disable": "Desactivar",
  "settings.webhooks.enable": "Activar",
  "settings.webhooks.sendTest": "Enviar evento de prueba",
  "settings.webhooks.edit": "Editar",
  "settings.webhooks.deleteConfirm": "¿Eliminar el webhook «{name}»?",
  "settings.webhooks.nameRequired": "El nombre es obligatorio",
  "settings.webhooks.urlRequired": "La URL es obligatoria",
  "settings.webhooks.saveFailed": "No se pudo guardar el webhook",
  "settings.webhooks.editTitle": "Editar webhook",
  "settings.webhooks.name": "Nombre *",
  "settings.webhooks.namePlaceholder": "Mi webhook",
  "settings.webhooks.secret": "Secreto",
  "settings.webhooks.secretKeep": "(déjelo vacío para conservar el actual)",
  "settings.webhooks.secretRecommended": "(recomendado)",
  "settings.webhooks.secretPlaceholder": "Secreto opcional para la firma HMAC",
  "settings.webhooks.signed": "Si se define, cada envío se firma en esta cabecera:",
  "settings.webhooks.noneChosen": "(ninguno elegido: todos)",
  "settings.webhooks.saveChanges": "Guardar cambios",
  "settings.messages.who": "Quién recibe este texto",
  "settings.messages.who.everyone": "Todos, sea cual sea su idioma",
  "settings.messages.who.perLanguage": "Por idioma: los demás reciben el texto predeterminado en su idioma",
  "settings.messages.language": "Idioma",
  "settings.messages.hasOwnText": "tiene texto propio",
  "settings.messages.everyoneHint": "Se escribe una vez y se envía a todos tal cual. Las partes que no cambie siguen el idioma de cada persona.",
  "settings.messages.languageHint": "Quien lee en {language} recibe este texto; hasta que lo cambie, se muestra el texto predeterminado en {language}.",
  "settings.messages.removeLanguage": "Quitar el texto en {language}",
  "settings.messages.removeLanguageConfirm": "¿Quitar el texto en {language} de «{label}»? Quien lea en {language} recibirá el texto predeterminado.",
  "settings.messages.removed": "Texto quitado",
  "settings.tabs": "Secciones de la configuración",
  "settings.tab.general": "General",
  "settings.tab.security": "Seguridad",
  "settings.tab.monitoring": "Supervisión y alertas",
  "settings.tab.messaging": "Mensajería",
  "settings.tab.licence": "Licencia",
  "settings.unsaved": "cambios sin guardar",
  "settings.languageTime": "Idioma y zona horaria",
  "settings.messaging.none": "Su licencia no incluye servidor de correo propio, WhatsApp ni RCS: los mensajes salen a través de la plataforma.",
  "settings.logo.title": "Logotipo",
  "settings.logo.alt": "Logotipo de {name}",
  "settings.logo.hint": "Muestra la empresa donde la elige después de iniciar sesión, y en las listas. Cualquier imagen (PNG, JPEG, WebP, GIF, SVG, AVIF…), hasta 10 MB; se escala a 256 × 256.",
  "settings.logo.choose": "Elegir imagen",
  "settings.logo.change": "Cambiar imagen",
  "settings.logo.remove": "Quitar logotipo",
  "settings.logo.removeConfirm": "¿Quitar el logotipo de {name}?",
  "settings.logo.saved": "Logotipo guardado",
  "settings.logo.removed": "Logotipo quitado",
  "settings.logo.notSaved": "Logotipo no guardado",
  "settings.logo.wrongType": "Elija un archivo de imagen",
  "settings.logo.tooLarge": "La imagen supera los 10 MB",
  "settings.logo.unreadable": "Este navegador no puede abrir esta imagen: guárdela como PNG o JPEG e inténtelo de nuevo",
  "settings.banner.title": "Logotipo de banner",
  "settings.banner.hint": "Se muestra en el centro de la barra superior en lugar del nombre de la empresa. Una imagen ancha, de cualquier tipo (PNG, JPEG, WebP, GIF, SVG, AVIF…), hasta 10 MB.",
  "settings.banner.remove": "Eliminar el logotipo de banner",
  "settings.banner.removeConfirm": "¿Eliminar el logotipo de banner de {name}?",
  "settings.banner.saved": "Logotipo de banner guardado",
  "settings.banner.removed": "Logotipo de banner eliminado",
  "settings.banner.notSaved": "Logotipo de banner no guardado",
  "settings.tab.rental": "Alquiler",
  "settings.tab.connections": "Conexiones",
  "settings.connections.intro": "Los controladores a través de los que se llega a tus sitios. Cada uno se comprueba al guardarlo; un secreto no se vuelve a mostrar.",
  "settings.connections.none": "Aún no hay conexiones: añada una desde la página Sitios.",
  "settings.connections.saved": "Conexión guardada",
  "settings.connections.saveFailed": "No se pudo guardar la conexión",
  "settings.connections.deleted": "Conexión eliminada",
  "settings.connections.deleteFailed": "No se pudo eliminar la conexión",
  "settings.connections.sites": { one: "{count} sitio", other: "{count} sitios" },
  "settings.connections.checked": "comprobada {when}",
  "settings.connections.waiting": "Esperando la conexión VPN del controlador: descarga su .ovpn e inícialo en el equipo del controlador.",
  "settings.connections.save": "Guardar",
  "settings.connections.addSites": "Añadir sitios",
  "settings.connections.edit": "Editar",
  "settings.connections.deleteConfirm": "¿Eliminar la conexión {name}?",
  "settings.connections.newCert": "Certificado nuevo",
  "settings.connections.newCertDone": "Certificado nuevo emitido: descarga el .ovpn e inícialo en el equipo del controlador",
  "settings.connections.newCertFailed": "No se pudo emitir un certificado nuevo",
  "settings.phonesStay": "Los teléfonos pueden mantener la sesión (la aplicación móvil, abierta con Face ID o una huella)",
  "settings.phonesStayHelp": "El límite de inactividad anterior también cuenta el tiempo en la aplicación; después, el teléfono vuelve a pedir Face ID.",
  "settings.phonesOffConfirm": "¿Desactivarlo? Al guardar, se cierra la sesión de todos los teléfonos de la empresa y volverán a pedir la contraseña.",
  "settings.messages.part.pushTitle": "Título de la notificación push",
  "settings.messages.part.pushBody": "Texto de la notificación push",
  "settings.messages.sentPush": "Enviado por notificación push (aplicación móvil)",
  "settings.messages.pushNote": "Se muestra en la pantalla de bloqueo del teléfono bajo el nombre de la aplicación Velanox; como máximo 100 y 500 caracteres.",
  "settings.messages.pushPreview": "Aplicación Velanox · notificación push",
  "settings.simPins.title": "Tarjetas SIM",
  "settings.simPins.help": "El PIN de la empresa para las SIM de los routers Teltonika, y las SIM con un PIN propio. Los PIN se muestran como puntos; Mostrar le pide su contraseña y queda registrado.",
  "settings.simPins.companyPin": "PIN de la empresa",
  "settings.simPins.notSet": "Sin establecer",
  "settings.simPins.set": "Establecer",
  "settings.simPins.save": "Guardar",
  "settings.simPins.newCompanyPin": "Nuevo PIN de la empresa (de 4 a 8 dígitos)",
  "settings.simPins.changeHelp": "Las SIM ya bloqueadas con el PIN actual de la empresa lo conservan como PIN propio.",
  "settings.simPins.show": "Mostrar",
  "settings.simPins.ownPins": "SIM con un PIN propio",
  "settings.simPins.noOwn": "Ninguna todavía.",
  "settings.simPins.removeConfirm": "¿Olvidar el PIN de la SIM {iccid}?",
  "settings.simPins.notShown": "No se mostró el PIN",
  "settings.simPins.notSaved": "No guardado",
  "settings.simPins.removeNoteConfirm": "¿Olvidar la nota de la SIM {iccid}? Sigue con el PIN de la empresa.",
  "settings.pushFirst.title": "Primero push",
  "settings.pushFirst.companyIntro": "Se aplica al WhatsApp y al RCS propios de esta empresa.",
  "settings.pushFirst.on": "El push va primero",
  "settings.pushFirst.onHelp": "Una alerta va por push a quien tiene la aplicación; WhatsApp o RCS solo siguen si no se vio dentro de la espera.",
  "settings.pushFirst.wait": "Espera antes de WhatsApp o RCS (minutos)",
  "settings.pushFirst.waitRange": "De 1 a 60 minutos enteros",
  "settings.pushFirst.anyone": "Omitir WhatsApp y RCS en cuanto alguien lo haya visto",
  "settings.pushFirst.anyoneHelp": "Un colega que abre el sitio cuenta para todos los avisados.",
  "settings.pushFirst.save": "Guardar",
  "settings.backdrop.dark": "Fondo en modo oscuro",
  "settings.backdrop.light": "Fondo en modo claro",
  "settings.backdrop.none": "Ninguno",
  "settings.backdrop.default.dark": "Blanco cálido",
  "settings.backdrop.default.light": "Oscuro del panel",
  "settings.backdrop.own": "Color propio",
  "settings.backdrop.colour.dark": "Color del fondo en modo oscuro",
  "settings.backdrop.colour.light": "Color del fondo en modo claro",
  "settings.backdrop.saved": "Fondo guardado",
  "settings.backdrop.notSaved": "Fondo no guardado",
  "settings.backdrop.help": "Para una imagen que desaparece en uno de los modos: un fondo claro detrás de letras oscuras, uno oscuro detrás de letras claras.",
}

export default settings
